import axios from 'axios';
import { variables } from '../Variables';

export const getClientEmail = async (clientId) => {
    try {
        let url = `${variables.API_URL}LocalEvents/GetClientEmail?clientId=${clientId}&key=7fb421351551`;
        const response = await axios.get(url);
        if (response.data) {
            return response.data.data;
        }
    } catch (error) {
        console.log(error);
    }
}
